import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';

export function createVectorSource() {
  const source = new VectorSource({ wrapX: false });
  const layer = new VectorLayer({ source });
  return { source, layer };
}
